export default "__VITE_ASSET__271c88b6__"